export const getGoogleMapsHref = (address: string) => `https://www.google.com/maps?q=${encodeURIComponent(address)}`
